import { AdminScreen, AdminScreenKey } from '../../types/admin-roles';

/**
 * #1113 — a one-line hint under a screen whose name alone does not say what it grants. Keyed by
 * screen key; the labels themselves come from identity's catalog.
 */
export const SCREEN_HINTS: Partial<Record<AdminScreenKey, string>> = {
  'finance-config': 'Edit service fee, Tabby, delivery margin and promotions cap. Not included in Finance.',
  dealers: 'Dealer credit: dealers, their users, packs, requests and mark-paid. A discount at or above break-even also needs Finance configuration.',
};

interface ScreenPickerProps {
  screens: AdminScreen[];
  selected: AdminScreenKey[];
  onToggle: (key: AdminScreenKey) => void;
  disabled?: boolean;
}

/**
 * Spec 050 — screen checkboxes for the role editor, grouped the way the catalog
 * declares them so the list reads like the sidebar rather than an alphabet soup.
 */
export default function ScreenPicker({ screens, selected, onToggle, disabled }: ScreenPickerProps) {
  const groups = screens.reduce<Record<string, AdminScreen[]>>((acc, screen) => {
    (acc[screen.group] ??= []).push(screen);
    return acc;
  }, {});

  return (
    <div className="admin-screen-picker">
      {Object.entries(groups).map(([group, items]) => (
        <fieldset key={group} className="admin-screen-group">
          <legend className="admin-screen-group-label">{group}</legend>
          <div className="admin-screen-group-items">
            {items.map((screen) => (
              <label key={screen.key} className="admin-screen-item">
                <input
                  type="checkbox"
                  checked={selected.includes(screen.key)}
                  onChange={() => onToggle(screen.key)}
                  disabled={disabled}
                  aria-describedby={SCREEN_HINTS[screen.key] ? `screen-hint-${screen.key}` : undefined}
                />
                <span>
                  {screen.label}
                  {SCREEN_HINTS[screen.key] && (
                    <span className="admin-screen-hint" id={`screen-hint-${screen.key}`}>{SCREEN_HINTS[screen.key]}</span>
                  )}
                </span>
              </label>
            ))}
          </div>
        </fieldset>
      ))}
    </div>
  );
}
